export {
  productRulesListScreen,
  productRuleDetailScreen,
  ruleProductsScreen,
} from './credit-product-rules.screen';
export {
  productRulesSearch,
  productRuleDetailSearch,
  ruleProductsSearch,
} from './credit-product-rules.search';
export { loadProductRulesMessages } from './credit-product-rules.catalog';
export const loadProductRulesScreens = () => import('./screens');

/** Os guias das telas para o Luy (U46), sob demanda. */
export const loadProductRulesGuides = () => import('./credit-product-rules.guide');
